import { Component, Input, OnChanges } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { TruncatedFilePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-files-datafile",
	templateUrl: "./files-datafile.component.html",
	styleUrls: ["./files-datafile.component.scss"]
})
export class FilesDatafileComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;
	@Input()
	filetype: string;

	public datafiles: APIResults.DataFile[];
	public expandFilename = true;

	public startDate: Date;
	public endDate: Date;

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await this.RefreshData();
	}

	public async RefreshData() {
		this.datafiles = undefined;
		const datafiles = await this.api.GetDataFiles(this.asset.asset_id, this.filetype, this.startDate, this.endDate, 0, (this.startDate && this.endDate) ? undefined : 1000);
		this.datafiles = datafiles;
	}

	public async DownloadFile(datafile: APIResults.DataFile) {
		let filename;
		if (this.expandFilename) {
			filename = datafile.filename.replace("/", "_");
		} else {
			filename = new TruncatedFilePipe().transform(datafile.filename);
		}
		await this.api.DownloadDataFile(this.asset.asset_id, datafile.datafile_id, filename);
	}
}
